
import { Vue } from "vue-class-component";

export default class StiDestSc extends Vue {}
